import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import ArchitecturalRequestLetterModal from "./ArchitecturalRequestLetters";
import ViolationsLetters from "./ViolationLetterTemplatesPage";

const TabPanel = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
  </div>
);

const CoverLetters = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#223142",
            mb: 0.5,
          }}
        >
          Notification Letters
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#6b778c",
          }}
        >
          Manage architectural request and violation letter templates in one place.
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          border: "1px solid rgba(47,99,173,0.08)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          backgroundColor: "rgba(255,255,255,0.96)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            pt: 2.5,
            pb: 1.5,
            borderBottom: "1px solid rgba(47,99,173,0.08)",
            backgroundColor: "rgba(47,99,173,0.02)",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#223142",
              mb: 0.5,
            }}
          >
            Letter Management
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#6b778c",
              mb: 2,
            }}
          >
            Switch between architectural request letters and violation letters.
          </Typography>

          <Tabs
            value={tab}
            onChange={(_, newValue) => setTab(newValue)}
            sx={{
              minHeight: "auto",
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "10px",
                minHeight: 42,
                color: "#5f6b7a",
                mr: 1,
                px: 2,
              },
              "& .Mui-selected": {
                color: "#2f63ad !important",
                backgroundColor: "rgba(47,99,173,0.08)",
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            <Tab label="Architectural Request Letters" />
            <Tab label="Violation Letters" />
          </Tabs>
        </Box>

        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <TabPanel value={tab} index={0}>
            <ArchitecturalRequestLetterModal
              open={true}
              onClose={() => {}}
              type={"Approved"}
              member={{
                FirstName: "Jane",
                LastName: "Doe",
                EmailAddress: "jane.doe@example.com",
                FullAddress: "123 Main St",
              }}
              requestDetails={{
                id: 101,
                description: "Backyard patio extension",
                priority: "High",
                requested_at: new Date(),
                property_id: 7,
              }}
              onLetterReady={(blob, content, sent) => {
                console.log("Letter ready", { blob, content, sent });
              }}
            />
          </TabPanel>

          <TabPanel value={tab} index={1}>
            <ViolationsLetters />
          </TabPanel>
        </Box>
      </Paper>
    </Box>
  );
};

export default CoverLetters;
